import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';
import { mapStateToProps, mapDispatchToProps } from '../../utils';

import ContentContainer from '../../components/ContentContainer';
import EditProfileSummary from '../../components/EditProfileSummary';

const ARROW = require('./arrow.png');

class JoinComplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      completed: false,
      adding: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        active: true,
      });
    }, 0);
  }

  getUserImage() {
    const user = this.props.user;

    if (user.image_url && user.image_url.length > 10) {
      return user.image_url;
    }

    if (user.profile_photo && user.profile_photo.length > 10) {
      return user.profile_photo;
    }

    return '/images/default_profile.jpg';
  }

  getDogImage(dog) {
    if (dog.image_url && dog.image_url.length > 10) {
      return dog.image_url;
    }

    if (dog.profile_photo && dog.profile_photo.length > 10) {
      return dog.profile_photo;
    }

    return '/images/default_dog.jpg';
  }

  getDogs() {
    return this.props.user.dogs.map(dog => (
      <EditProfileSummary
        id={dog.id}
        image_url={this.getDogImage(dog)}
        name={dog.name}
        breed={dog.breed} />
    ));
  }

  render() {
    const hasDogs = this.props.user.subscription === 'Owner' &&
                    this.props.user.dogs && this.props.user.dogs.length;

    return (
      <div className={css(
        styles.container,
        this.state.active ? styles.container_active : null,
        this.state.completed ? styles.container_completed : null,
      )}>
        <ContentContainer>
          <h1 className={css(styles.heading)}>
            Nice! Your{hasDogs ? ' dog\'s' : false} profile has been updated
          </h1>
          <div className={css(styles.sub_heading)}>
            You can update {hasDogs ? 'their' : 'your'} info at anytime via this menu
            <img
              src={ARROW}
              className={css(styles.arrow)}
              alt="Your can update your dog any time via this menu" />
          </div>
          <div className={css(styles.main)}>
            <div className={css(styles.profiles)}>
              {
                hasDogs ? this.getDogs() : (
                  <EditProfileSummary
                    dog={false}
                    id={this.props.user.id}
                    image_url={this.getUserImage()}
                    name={this.props.user.display_name} />
                )
              }
            </div>
            <div className={css(styles.actions)}>
              {
                this.props.user.subscription === 'Owner' ? (
                  <Link
                    to={'/join/pooch'}
                    className={css(styles.draft)}
                    onClick={this.saveDraft}>
                    Add {hasDogs ? 'another' : 'a'} pooch
                  </Link>
                ) : false
              }
              <Link
                to={'/shares'}
                className={css(styles.publish)}
                onClick={this.savePublish}>
                Go to my dog shares
              </Link>
            </div>
          </div>
        </ContentContainer>
      </div>
    );
  }
}

JoinComplete.propTypes = {
  user: PropTypes.object.isRequired,
};

const styles = StyleSheet.create({
  container: {
    padding: `86px 0 ${Theme.footer.height}px`,
    transition: 'transform 500ms',
    transform: 'translateX(100vw)',
  },
  container_active: {
    transform: 'translateX(0)',
  },
  container_completed: {
    transform: 'translateX(-100vw)',
  },
  main: {
    width: 750,
    margin: '0 auto',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  arrow: {
    position: 'absolute',
    top: -108,
    right: 120,
    maxWidth: 178,
    maxHeight: 108,

    [Theme.mobile_query]: {
      display: 'none',
    },
  },
  heading: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  sub_heading: {
    position: 'relative',
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: Theme.font_family_primary,
    fontWeight: 400,
    fontSize: 18,
    color: '#000e1f',
    textAlign: 'center',
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  draft: {
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: '#39b4d6',
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: Theme.white,
    cursor: 'pointer',
    outline: 'none',
    textAlign: 'center',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  publish: {
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#56C5FF',
    cursor: 'pointer',
    outline: 'none',
    textAlign: 'center',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(JoinComplete);



// WEBPACK FOOTER //
// ./src/views/JoinComplete/index.js